import { LandingHeader } from '@modules/Landing/Components/DesktopLanding/LandingHeader/LandingHeader';
import css from './DesktopLanding.module.css';
import { DesktopLandingGifsSection } from '@shared/Features/DesktopLandingGifsSection/DesktopLandingGifsSection';
import FAQSection from '@shared/Features/FAQSection/FAQSection';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { ShimmerLoader } from '@shared/Ui/Loaders/ShimmerLoader/ShimmerLoader';
import { TemplatesTypesSection } from '@modules/Landing/Components/DesktopLanding/TemplatesTypesSection/TemplatesTypesSection';

export const DesktopLanding: React.FC = () => {
    const [bannerUrl, setBannerUrl] = useState<string>('');

    useEffect(() => {
        const loadBanner = async () => {
            try {
                const module = await import(
                    '@assets/Imgs/LandingBanners/landingBannerDesktop.png'
                );
                setBannerUrl(module.default);
            } catch (error) {
                setBannerUrl('');
            }
        };
        loadBanner();
    }, []);

    return (
        <section className={css.section}>
            <LandingHeader />
            <div className={css.bannerWrapper}>
                {!bannerUrl ? (
                    <ShimmerLoader>
                        <div
                            className={classNames(css.bannerPlaceholder, {
                                [css.transparent]: bannerUrl,
                            })}
                        />
                    </ShimmerLoader>
                ) : (
                    <div className={css.bannerImgWrapper}>
                        <img
                            src={bannerUrl}
                            className={css.banner}
                            alt="banner"
                        />
                    </div>
                )}
            </div>
            <DesktopLandingGifsSection />
            <TemplatesTypesSection />
            <FAQSection />
        </section>
    );
};
